<template>
  <!-- carousel design -->
  <div>
    <div class="relative">
      <div
        id="iwp_gallery_carousel"
        class="app__body"
      >
        <div class="app__body-carousel relative">
          <div class="overflow-hidden">
            <transition
              :name="transitionName"
              mode="out-in"
            >
              <div
                :key="carouselNumber"
                class="slide slide-img  items-center justify-center"
              >
                <img
                  :id="'iwp_gallery_carousel_image'"
                  :src="slideActive.url + imageSize"
                  class="carousel-img"
                  :class="'iwp_carousel_img_' + carouselNumber"
                  alt="image"
                >
              </div>
            </transition>
            <div>
              <div
                v-if="carouselType==false ? carouselNumber > 1 : carouselType"
                class="top-1/2 -translate-y-1/2 left-4 hover:bg-white z-10 w-8 h-8 cursor-pointer flex justify-center items-center absolute rounded-full border border-grayCust-900 bg-grayCust-1000 text-white hover:text-primary-900"
                @click="previousSlide"
              >
                <GalleryArrowIcon />
              </div>
              <div
                v-if="carouselType==false ? carouselNumber < carouselData.length : carouselType"
                class="top-1/2 -translate-y-1/2 right-4 hover:bg-white z-10 w-8 h-8 cursor-pointer flex justify-center items-center absolute rounded-full border border-grayCust-900 bg-grayCust-1000 text-white hover:text-primary-900 transform rotate-180"
                @click="nextSlide"
              >
                <GalleryArrowIcon />
              </div>
            </div>
          </div>
          <div
            class="slider-dots slide-main absolute dots left-1/2 -translate-x-1/2 flex items-center justify-center w-full"
            style="bottom: 20px;"
          >
            <div 
              v-for="dot in carouselData.length"
              :key="dot"
              :class="'dot--' + dot" 
              class="dot bg-grayCust-900 h-1.5 cursor-pointer rounded-full z-30 mr-2"
            />
          </div>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
import GalleryArrowIcon from '@/Common/GalleryArrowIcon.vue';
export default {
   name:"Gallery",
   components: {
      GalleryArrowIcon,
   },
   props:{
      carouselData:{ 
      },
      carouselType:{
         type:Boolean,
         default:false,
      },
      displaySettings: {
         type: Object,
         default: {
            primaryColor: '#15B881',
            accentColor: '#ffffff',
         },
      }
   },
   data() {
      return {
         carouselNumber: 1,
         direction: "next",
         imageSize: '?' + window.configs.imageSettings.launchGallery,
      }
   },
   computed: {
      slideActive() {
         return this.carouselData[this.carouselNumber - 1];
      },
      transitionName() {
         return `fade-${this.direction}`;
      },
      ActiveDotCoordinate() {
         return `calc(${parseInt(100 * (this.carouselNumber - 1))}% + ${parseFloat(0.3 * (this.carouselNumber - 1))}rem)`;
      },
   },
   methods: {
      nextSlide() {
         this.direction = "next";
         if(this.carouselData.length==this.carouselNumber && this.carouselType){
            this.carouselNumber=1
         }
         else{
            this.carouselNumber++;
         }
         this.handleNextDot();
      },
      previousSlide() {
         this.direction = "prev";
         if(this.carouselNumber<=1 && this.carouselType){
            this.carouselNumber=this.carouselData.length;
         }
         else{
            this.carouselNumber--;
         }
         this.handlePreviousDot();
      },
      handleNextDot() {
         document.querySelector(".dot--1").style.transform = `translateX(${this.ActiveDotCoordinate})`;
         document.querySelector(`.dot--${this.carouselNumber}`).style.transform = `translateX(calc(-100% - .3rem))`;
      },
      handlePreviousDot() {
         document.querySelector(".dot--1").style.transform = `translateX(${this.ActiveDotCoordinate})`;
         document.querySelector(`.dot--${this.carouselNumber + 1}`).style.transform = `translateX(0)`;
      },
 },
}
</script>

<style scoped>

</style>